const styles = {
  container:
    'bg-black bg-opacity-25 hover:bg-opacity-30 flex justify-center items-center rounded-full w-12 h-12 cursor-pointer',
  fillColor: '#DC2626',
};

export default styles;
